import { getLoadingPhaseKind, isInternetSearchPhase } from "./loadingPhaseCatalog";

export const getLoadingPhaseMeta = (phaseText = "", darkMode = false) => {
  const kind = getLoadingPhaseKind(phaseText);

  if (kind === "search") {
    return {
      kind,
      accent: "#22D3A6",
      secondaryAccent: "#7CF0CE",
      eyebrow: "Live Web Search",
      description: "Reconciling fresh sources before the final answer lands.",
      detail: "Source graph online",
      haloBackground: darkMode
        ? "radial-gradient(circle, rgba(22,111,88,0.42) 0%, rgba(6,13,15,0) 72%)"
        : "radial-gradient(circle, rgba(34,211,166,0.2) 0%, rgba(255,255,255,0) 74%)",
      dashedBorder: darkMode
        ? "rgba(101,233,194,0.34)"
        : "rgba(33,167,136,0.3)",
      ringBorder: darkMode
        ? "rgba(96,225,187,0.5)"
        : "rgba(33,163,132,0.42)",
      ringGlow: darkMode
        ? "0 0 52px rgba(18, 136, 104, 0.26)"
        : "0 0 44px rgba(33, 167, 136, 0.18)",
      centerBackground: darkMode
        ? "radial-gradient(circle at 30% 18%, rgba(30,128,103,0.38), rgba(8,18,19,0.94) 70%)"
        : "radial-gradient(circle at 32% 22%, rgba(91,237,200,0.26), rgba(241,255,251,0.98) 74%)",
      centerBorder: darkMode
        ? "rgba(109,229,194,0.58)"
        : "rgba(43,168,137,0.42)",
      headingColor: darkMode ? "#B9FFEC" : "#0E6651",
      titleColor: darkMode ? "#ECFFF9" : "#0B3B32",
      bodyColor: darkMode ? "rgba(194,246,232,0.94)" : "rgba(19,97,80,0.92)",
      labelBorder: darkMode
        ? "rgba(80,148,125,0.56)"
        : "rgba(125,221,194,0.85)",
      labelBackground: darkMode
        ? "rgba(11,28,24,0.88)"
        : "rgba(241,255,250,0.95)",
      labelColor: darkMode ? "#CFFFF0" : "#116451",
      panelBackground: darkMode
        ? "linear-gradient(140deg, rgba(11,30,25,0.96), rgba(7,17,18,0.94))"
        : "linear-gradient(140deg, rgba(244,255,252,0.98), rgba(231,252,245,0.96))",
      panelBorder: darkMode
        ? "rgba(76,156,130,0.48)"
        : "rgba(93,208,171,0.5)",
      panelShadow: darkMode
        ? "0 16px 34px rgba(0,0,0,0.34)"
        : "0 14px 30px rgba(34, 161, 131, 0.14)",
      panelTextColor: darkMode ? "#EDFFFA" : "#123E35",
      panelMutedColor: darkMode ? "#BFEFDF" : "#2A7863",
    };
  }

  return {
    kind,
    accent: "#249DFF",
    secondaryAccent: "#84C4FF",
    eyebrow: "Loading Phase",
    description: "Running analysis tasks across the current directive stack.",
    detail: "Analysis in motion",
    haloBackground: darkMode
      ? "radial-gradient(circle, rgba(22,36,58,0.48) 0%, rgba(7,10,16,0) 70%)"
      : "radial-gradient(circle, rgba(26,125,255,0.22) 0%, rgba(255,255,255,0) 72%)",
    dashedBorder: darkMode
      ? "rgba(133,168,217,0.32)"
      : "rgba(45,102,183,0.26)",
    ringBorder: darkMode
      ? "rgba(123,170,235,0.44)"
      : "rgba(38,119,228,0.36)",
    ringGlow: darkMode
      ? "0 0 46px rgba(20, 83, 168, 0.22)"
      : "0 0 42px rgba(30, 118, 230, 0.2)",
    centerBackground: darkMode
      ? "radial-gradient(circle at 30% 18%, rgba(41,89,166,0.34), rgba(12,18,28,0.9) 68%)"
      : "radial-gradient(circle at 32% 22%, rgba(102,177,255,0.34), rgba(243,250,255,0.95) 72%)",
    centerBorder: darkMode
      ? "rgba(98,142,204,0.64)"
      : "rgba(71,137,232,0.5)",
    headingColor: darkMode ? "#8fb6ef" : "#2c67b9",
    titleColor: darkMode ? "#e7f1ff" : "#143f7a",
    bodyColor: darkMode ? "rgba(177,201,238,0.92)" : "rgba(36,88,155,0.9)",
    labelBorder: darkMode
      ? "rgba(85,124,177,0.56)"
      : "rgba(146,181,230,0.8)",
    labelBackground: darkMode
      ? "rgba(16,25,39,0.86)"
      : "rgba(246,251,255,0.95)",
    labelColor: darkMode ? "#d8e8ff" : "#144a95",
    panelBackground: darkMode
      ? "linear-gradient(140deg, rgba(20,27,39,0.96), rgba(10,13,20,0.94))"
      : "linear-gradient(140deg, rgba(248,252,255,0.98), rgba(235,243,255,0.96))",
    panelBorder: darkMode
      ? "rgba(80,109,160,0.45)"
      : "rgba(133,168,228,0.48)",
    panelShadow: darkMode
      ? "0 16px 34px rgba(0,0,0,0.3)"
      : "0 14px 30px rgba(37, 103, 185, 0.12)",
    panelTextColor: darkMode ? "#EFF5FF" : "#123A67",
    panelMutedColor: darkMode ? "#BED1EE" : "#40689E",
  };
};

export { isInternetSearchPhase };
